import { Alert } from './model';
import { AlertActions, AlertActionTypes } from './actions';
import { createSelector, ActionReducerMap } from '@ngrx/store';

export interface State {
  alerts: Alert[];
}

export function reducer(state = [], action: AlertActions): Alert[] {
  switch (action.type) {
    case AlertActionTypes.Add:
      const lastIndex = state.length - 1;
      const lastId = lastIndex > -1 ? state[lastIndex].id : 0;
      const alert = {
        ...action.payload.alert,
        id: lastId + 1,
        translate: !!action.payload.alert.translate,
        closable:
          action.payload.alert.closable !== undefined
            ? action.payload.alert.closable
            : true,
        endTime: action.payload.alert.endTime || 0,
      };
      return [...state, alert];

    case AlertActionTypes.Remove:
      return [
        ...state.filter(({ id }) => action.payload.ids.indexOf(id) === -1),
      ];

    case AlertActionTypes.Clean:
      return [];

    default:
      return state;
  }
}

export const alertReducers: ActionReducerMap<State> = {
  alerts: reducer,
};

const headerAlertSelector = state => state.headerAlert;

const headerAlertsState = (state: any) => state.alerts;
export const getAlerts = createSelector(headerAlertSelector, headerAlertsState);
